var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2598 13.5454C9.29247 14.0573 8.19377 14.3465 7.02889 14.3465C3.14694 14.3465 0 11.1349 0 7.17325C0 3.21157 3.14694 0 7.02889 0C10.9108 0 14.0578 3.21157 14.0578 7.17325C14.0578 9.26696 13.1788 11.1512 11.7769 12.4625L15.5794 17.1664C15.7286 17.351 15.5308 17.7689 15.1377 18.0999C14.7446 18.4309 14.3049 18.5496 14.1557 18.365L10.2598 13.5454ZM11.895 7.17325C11.895 9.91595 9.71639 12.1393 7.02889 12.1393C4.34139 12.1393 2.16273 9.91595 2.16273 7.17325C2.16273 4.43055 4.34139 2.20715 7.02889 2.20715C9.71639 2.20715 11.895 4.43055 11.895 7.17325Z","fill":"#333333"}));
}

IconSearch.defaultProps = {"width":"16","height":"19","viewBox":"0 0 16 19","fill":"none"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
